import {
  ArrowSquareOut,
  ArrowsLeftRight,
  ArrowUpRight,
  Barbell,
  Bed,
  Bell,
  BellSlash,
  BookmarkSimple,
  BookOpen,
  BowlFood,
  Brain,
  Buildings,
  CalendarBlank,
  CalendarCheck,
  CaretDown,
  ChartLineUp,
  ChatCircle,
  Check,
  CheckCircle,
  Circle,
  CircleHalf,
  Clock,
  CloudRain,
  CloudSun,
  Coffee,
  Compass,
  Desktop,
  DeviceMobile,
  Drop,
  DropHalf,
  Egg,
  FingerprintSimple,
  FirstAid,
  FirstAidKit,
  Flag,
  Flower,
  Footprints,
  ForkKnife,
  Gauge,
  HandPalm,
  Heart,
  Heartbeat,
  HeartStraight,
  type Icon,
  Info,
  Keyboard,
  Lightning,
  LinkSimple,
  ListChecks,
  MagnifyingGlass,
  MapPin,
  Moon,
  Note,
  PersonSimpleRun,
  PersonSimpleSwim,
  PersonSimpleWalk,
  Pill,
  PlayCircle,
  Plus,
  PlusCircle,
  Prohibit,
  Pulse,
  Repeat,
  Scales,
  SealCheck,
  Sliders,
  Smiley,
  SmileyMeh,
  SmileySad,
  Sparkle,
  Sun,
  SunHorizon,
  Syringe,
  Target,
  TestTube,
  Thermometer,
  TrendDown,
  TrendUp,
  Users,
  UsersThree,
  VideoCamera,
  Warning,
  WarningCircle,
  Watch,
  WifiSlash,
  Wind,
  Wine,
  X,
} from "@phosphor-icons/react";

// Resolves a Phosphor icon NAME (kebab-case, as carried in graph/signal data)
// to its React component. Node glyphs are data-driven, so the fingerprint and
// the graphs need a name -> component lookup rather than static imports. Keep
// this in lockstep with the icon names emitted by `@healthos/shared`'s
// signal-visual map and the graph read models.
const REGISTRY: Record<string, Icon> = {
  "arrow-square-out": ArrowSquareOut,
  "arrows-left-right": ArrowsLeftRight,
  "arrow-up-right": ArrowUpRight,
  barbell: Barbell,
  bed: Bed,
  bell: Bell,
  "bell-slash": BellSlash,
  "book-open": BookOpen,
  "bookmark-simple": BookmarkSimple,
  "bowl-food": BowlFood,
  brain: Brain,
  buildings: Buildings,
  "calendar-blank": CalendarBlank,
  "calendar-check": CalendarCheck,
  "caret-down": CaretDown,
  "chart-line-up": ChartLineUp,
  "chat-circle": ChatCircle,
  check: Check,
  "check-circle": CheckCircle,
  circle: Circle,
  "circle-half": CircleHalf,
  clock: Clock,
  "cloud-rain": CloudRain,
  "cloud-sun": CloudSun,
  coffee: Coffee,
  // The Explore surface: the same glyph DEFAULT_NAV_ITEMS renders for it.
  compass: Compass,
  // Phosphor has no `Cup`. Drop is the nearest honest glyph for a fluid that
  // is not water, and is what the browser surface already rendered.
  cup: Drop,
  desktop: Desktop,
  "device-mobile": DeviceMobile,
  drop: Drop,
  "drop-half": DropHalf,
  egg: Egg,
  "first-aid": FirstAid,
  "first-aid-kit": FirstAidKit,
  flag: Flag,
  "fingerprint-simple": FingerprintSimple,
  footprints: Footprints,
  flower: Flower,
  "fork-knife": ForkKnife,
  gauge: Gauge,
  "hand-palm": HandPalm,
  heart: Heart,
  "heart-straight": HeartStraight,
  heartbeat: Heartbeat,
  info: Info,
  keyboard: Keyboard,
  lightning: Lightning,
  "link-simple": LinkSimple,
  "list-checks": ListChecks,
  "magnifying-glass": MagnifyingGlass,
  "map-pin": MapPin,
  moon: Moon,
  note: Note,
  "person-simple-run": PersonSimpleRun,
  "person-simple-swim": PersonSimpleSwim,
  "person-simple-walk": PersonSimpleWalk,
  pill: Pill,
  "play-circle": PlayCircle,
  plus: Plus,
  "plus-circle": PlusCircle,
  prohibit: Prohibit,
  pulse: Pulse,
  repeat: Repeat,
  scales: Scales,
  "seal-check": SealCheck,
  sliders: Sliders,
  smiley: Smiley,
  "smiley-meh": SmileyMeh,
  "smiley-sad": SmileySad,
  sparkle: Sparkle,
  sun: Sun,
  "sun-horizon": SunHorizon,
  syringe: Syringe,
  target: Target,
  "test-tube": TestTube,
  thermometer: Thermometer,
  "trend-down": TrendDown,
  "trend-up": TrendUp,
  users: Users,
  "users-three": UsersThree,
  "video-camera": VideoCamera,
  warning: Warning,
  "warning-circle": WarningCircle,
  watch: Watch,
  "wifi-slash": WifiSlash,
  wind: Wind,
  wine: Wine,
  x: X,
};

// Falls back to a neutral dot for an unmapped name, so a new signal/memory icon
// never renders as a broken glyph.
export function phosphorByName(name: string | undefined | null): Icon {
  if (!name) return Circle;
  return REGISTRY[name] ?? Circle;
}
